module.exports = __webpack_public_path__ + "static/img/prod_pic13.ace2e58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prod_pic13.jpg
// module id = 4YaX
// module chunks = 5